import { EndOfJourneyScanEnrollmentCandidate } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEndOfJourneyScanItemEnrollmentCandidates(itemId: number, search: string) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API['end-of-journey-scans'].getItemEnrollmentCandidates.url, {
          id: itemId
        }),
        { search: search || undefined }
      )
    )
    .get<EndOfJourneyScanEnrollmentCandidate[]>()
}
